// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__jkuzl","label":"Footer_label__YVDGC","input":"Footer_input__ZT+Y6","submit":"Footer_submit__uW0Mh"};